'use client'

import axios, { type AxiosError } from 'axios'
import useSwr, { type SWRResponse } from 'swr'

import { type TenantLanguage } from '../../../tenant'
import { PARCEL_LAB_BASE_URL } from '../../model/PARCEL_LAB_BASE_URL'
import { type ParcelLabResponse } from '../../model/ParcelLabTypes'

const getParcelLabTrackingUrl = (
  language: TenantLanguage,
  trackingId: string,
  courier: string,
): string => {
  const url = new URL(PARCEL_LAB_BASE_URL)

  url.searchParams.set('tno', trackingId)
  url.searchParams.set('courier', courier)
  url.searchParams.set('language', language)

  return url.href
}

export const useApiParcelLabSwrGetOrderStatus = (
  language: TenantLanguage,
  trackingId?: string,
  courier?: string | null,
): SWRResponse<ParcelLabResponse, AxiosError> => {
  const url =
    trackingId && courier
      ? getParcelLabTrackingUrl(language, trackingId, courier)
      : null

  const fetcher = async (requestUrl: string): Promise<ParcelLabResponse> => {
    const response = await axios.get<ParcelLabResponse>(requestUrl)

    return response.data
  }

  return useSwr(url, fetcher)
}
